import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, Bubble, Form } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';

import './index.scss';
import useFeedsUpdate from '@/pages/opinion/hooks/useFeedsUpdate';
import { initialUpperCase } from '@/pages/opinion/utils';
import { useIntl } from 'umi';
import DOMPurify from 'dompurify';

// 修改翻译弹窗
export default function TranslateEditPopup({
  visible,
  filter,
  close,
  editTranslate,
  origin,
  title,
}: any) {
  const { formatMessage } = useIntl();
  const {
    logLoading,
    loading,
    submit,
    setNewValue,
    newValue,
    modifiedValue,
    logList,
    getLogList,
  } = useFeedsUpdate({
    defaultValue: editTranslate,
    oldValue: editTranslate,
    filter,
    autoLoad: false,
  });

  const [message, setMessage] = useState('');
  const checkTextCorrect = (value?: string) => {
    let info: string | null = value ?? newValue;
    info = info?.trim() || null;
    if (info) {
      setMessage('');
      return info;
    }
    setMessage(formatMessage({ id: 'Translation cannot be empty' }));
  };

  useEffect(() => {
    if (visible) {
      getLogList();
    }
  }, [visible]);

  return (
    <>
      <Modal
        disableEscape
        className="dbo-feeds-editpopup"
        visible={visible}
        caption={formatMessage({ id: `${title} Translation Editing` })}
        onClose={() => {
          close();
        }}
      >
        <Modal.Body>
          <Form>
            <Form.Item
              className="dbo-feeds-editpopup-item"
              label={formatMessage({ id: 'Original Content' })}
            >
              <Form.Text className="dbo-feeds-editpopup-content">
                {origin}
              </Form.Text>
            </Form.Item>
            <Form.Item
              className="dbo-feeds-editpopup-item"
              label={formatMessage({ id: `${title} Translation` })}
              showStatusIcon={false}
              status={!message ? undefined : 'error'}
              message={message}
            >
              <Input.TextArea
                size="full"
                onChange={(value) => {
                  checkTextCorrect(value);
                  setNewValue(value);
                }}
                placeholder={formatMessage({
                  id: 'Please enter the translation',
                })}
                value={newValue}
              />
            </Form.Item>

            <Form.Item
              className="dbo-feeds-editpopup-item dbo-feeds-editpopup-historybox"
              label={formatMessage({
                id: `Editing History`,
              })}
            >
              <Form.Text className="dbo-feeds-editpopup-history">
                {logList.map(({ editor, create_time, new_value }, index) => {
                  return (
                    <div
                      key={create_time + new_value}
                      className="editpopup-history-item"
                    >
                      <div className="editpopup-history-item-hd">
                        <span className="editpopup-history-name">{editor}</span>
                        <span className="editpopup-history-text">
                          {create_time}
                        </span>
                      </div>
                      <div className="editpopup-history-item-bd">
                        {index === 0 && editTranslate !== new_value ? (
                          <Bubble
                            dark
                            closeOnScroll
                            content={formatMessage({ id: 'To be updated' })}
                          >
                            <div className="editpopup-history-icon">
                              <SvgIcon type="updating" />
                            </div>
                          </Bubble>
                        ) : null}
                        <span
                          className="editpopup-history-info"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(initialUpperCase(new_value)),
                          }}
                        ></span>
                      </div>
                    </div>
                  );
                })}
              </Form.Text>
            </Form.Item>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            disabled={modifiedValue?.trim() === newValue?.trim()}
            loading={loading}
            onClick={(e) => {
              submit();
              close();
            }}
          >
            {formatMessage({ id: 'Confirm' })}
          </Button>
          <Button type="weak" onClick={close} disabled={loading}>
            {formatMessage({ id: 'Cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
